const Breadcrumb = ({title}) => {
    return (
        <div className="bg-gray p-5 mb-5 text-center fs-1 fw-bold text-white breadcrumb-background">
            {title}
        </div>
    )
}

export default Breadcrumb;